import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {Injector} from "@angular/core";
import {environment} from "../environments/environment";

/**
 * @author Carlos Duardo <carlos.duardo@qualud.com>
 */
export class GlobalErrorConfig {
  static enable = true;
  static verbose: boolean = !environment.production;
  static message: string = 'Lo sentimos, a ocurrido un error interno. Si el error persiste recargue la página o consulte a los administradores.';

  static handleError(error: any, injector: Injector): void {
    const toaster = injector.get(ToastrService);
    const translator = injector.get(TranslateService);

    const verboseError = this.verbose ? '<br>' + error : '';
    const message = this.verbose ? 'Internal Error:' : translator.instant(this.message)

    toaster.error(verboseError, message);
  }
}
